import { createFileRoute } from "@tanstack/react-router"
import { lazyImportRouteComponent } from "../../../../utils/lazyImportRouteComponent"

export const Route = createFileRoute("/app/my/duty-roster/")({
  component: lazyImportRouteComponent(
    () => import("./-components/TimeTrackingListPage"),
    "TimeTrackingListPage"
  ),
  beforeLoad(context) {
    return {
      getTitle: () => context.context.t && context.context.t("Workhours"),
    }
  },
})
